import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CourseOverviewItem from './CourseOverviewItem';

const CourseOverview = ({ overviewData, isCloudTraining }) => {
  const [isAllExpanded, setIsAllExpanded] = useState(false);
  const { modules, bonus } = overviewData;

  const noOfWeeks = isCloudTraining ? overviewData.weeks : modules.length;

  const noOfModules = modules.reduce(
    (accumulator, currentValue) => accumulator + currentValue.length,
    0,
  );

  const noOfTopics = modules.reduce(
    (accumulator, currentValue) =>
      accumulator +
      currentValue.reduce(
        (topicAccumulator, currentTopic) =>
          topicAccumulator + currentTopic.topics.length,
        0,
      ),
    0,
  );

  return (
    <div className="course-overview">
      <div className="container">
        <h3 className="section-title">Course Overview</h3>
        <div className="section-details">
          {noOfWeeks} Weeks | {noOfModules} Modules | {noOfTopics} Topics
        </div>
        <div style={{ textAlign: 'right', marginBottom: 36 }}>
          <button
            className="expand-all-btn button-unstyled"
            onClick={() => setIsAllExpanded(!isAllExpanded)}
          >
            {isAllExpanded ? 'Collapse All' : 'Expand All'}
          </button>
        </div>
        <div className="course-table">
          {modules.map((week, weekIndex) =>
            week.map((mod, modIndex) => (
              <div className="module-container">
                {!isCloudTraining &&
                  <div
                    className={
                      !modIndex
                        ? 'week-number-container'
                        : 'week-number-container hidden'
                    }
                  >
                    <span className={!modIndex ? 'week' : 'week hidden'}>
                      Week
                  </span>
                    <span
                      className={!modIndex ? 'week-number' : 'week-number hidden'}
                    >
                      {weekIndex < 10 ? '0' : ''}
                      {weekIndex + 1}
                    </span>
                  </div>
                }
                <CourseOverviewItem
                  moduleData={mod}
                  isAllExpanded={isAllExpanded}
                  showTopics
                />
              </div>
            )),
          )}
          {bonus && bonus.length
            ? bonus.map((mod) => (
              <div style={{ display: 'flex' }}>
                <div className="week-number-container hidden">
                  <span className={'week hidden'}>Bonus</span>
                  <span className={'week-number hidden'}></span>
                </div>
                <CourseOverviewItem
                  moduleData={mod}
                  isAllExpanded={isAllExpanded}
                  showTopics={false}
                />
              </div>
            ))
            : null}
        </div>
      </div>
    </div>
  );
};

CourseOverview.propTypes = {
  overviewData: PropTypes.object,
  isCloudTraining: PropTypes.bool,
};

export default CourseOverview;
